/**
 * Set and remove the page meta attributes.
 * @param  {string} name
 * @param  {string} content
 */
export default function setMetaTagDomUtil (name, content) {
  // Remove and create a new <meta /> tag in order to make it work
  // with bookmarks in Safari
  let elements = window.document.getElementsByTagName('meta')
  elements = [].slice.call(elements)
  let key
  if (name.startsWith('og:')) {
    // Handle OpenGraph
    // Facebook
    // @see
    // https://developers.facebook.com/docs/sharing/webmasters/getting-started/basic-link/
    // Pinterest @see
    // https://developers.pinterest.com/docs/rich-pins/articles/?
    key = 'property'
  } else {
    key = 'name'
  }

  elements.forEach((element) => {
    if (element.getAttribute(key) === name) {
      element.parentNode.removeChild(element)
    }
  })

  const meta = window.document.createElement('meta')
  meta.setAttribute(key, name)
  meta.setAttribute('content', content)
  window.document.getElementsByTagName('head')[0].appendChild(meta)
}
